// extracted by mini-css-extract-plugin
export default {"nav":"BackToolbar_nav__8Bu0S","back":"BackToolbar_back__zb1p4","title":"BackToolbar_title__EtmMr","box":"BackToolbar_box__6qt1B"};